import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { ApplicationEmptyState, BaasicButton, GlobalSignalRListener, ScrollToTopButton } from 'core/components';
import { PreviewLayout } from 'core/layouts';
import { FacilityOrderTemplateNewFlowInsuranceEdit } from "application/facility-order-new-flow-insurance/components";
import { FacilityOrderNewFlowStatusBar } from "application/facility-order-new-flow-us-intake/components";
import { toDate } from "core/utils";
import moment from 'moment';
import { Tooltip as ReactTooltip } from "react-tooltip";

function FacilityOrderNewFlowInsurancePreviewTemplate({ facilityOrderNewFlowInsurancePreviewViewStore }) {
    const {
        loaderStore,
        facilityOrder,
        facilityOrderTemplateStores,
        itemCategoryStore,
        tabItems,
        selectedStatusAbrv,
        setStatus,
        downloadFacilityOrder,
        fetchingTemplates,
        facilityOrderStatus,
        setInsuranceStarted,
        setInsuranceCompleted,
        disabled,
        isInsuranceStatus,
        restartInsuranceReview,
        isStatusBarVisible,
        changeStatusBarVisibility,
        usIntakeStatus,
        disabledStatus,
        isDisabled,
        id,
        rootStore,
        signalRAction,
        pickTicketHeaderStatus,
        notification,
        goToFacilityPreview,
        goToFacilityCalendar,
        disabledSendOrder,
        isInventoryStepAllowed
    } = facilityOrderNewFlowInsurancePreviewViewStore;

    const tabButtons = tabItems ? tabItems.map(item =>
        <BaasicButton key={item.abrv}
            className={"tabs__item " + (item.abrv == selectedStatusAbrv ? 'active' : '')}
            label={item.name}
            onClick={() => item.abrv != selectedStatusAbrv ? setStatus(item.abrv) : {}}
        />
    ) : null;

    return (
        <PreviewLayout className="container container--new-flow" store={facilityOrderNewFlowInsurancePreviewViewStore} emptyRenderer={<ApplicationEmptyState />} layoutFooterVisible={false} loading={loaderStore.loading || fetchingTemplates}>
            <GlobalSignalRListener groupId={id} rootStore={rootStore} action={signalRAction} />
            {notification &&
                <div className='message__bar'>
                    <span>{notification} </span><a href="#" onClick={() => window.location.reload()} title="Reload Page" className='message__bar__btn'>Reload</a>
                </div>
            }
            {((pickTicketHeaderStatus && pickTicketHeaderStatus != "new") || (facilityOrder && facilityOrder.sendOrder)) &&
                <div className='purches-notification' style={notification && { marginTop: "28px" }}>
                    <div className='message__bar purches-notification-row' style={notification && { marginTop: "27px" }}>
                        <span>{pickTicketHeaderStatus === "in-progress" ? "Purchasing is in progress. Don't make changes to the facility order." : pickTicketHeaderStatus === "completed" ? "Purchasing is complete. Don't make changes to the facility order." : "Billing is in Progress, any changes made must be reported to the biller."}</span>
                    </div>
                </div>
            }
            <FacilityOrderNewFlowStatusBar facilityOrder={facilityOrder} title={facilityOrder && `${facilityOrder.facility.name} - DOS ${toDate(facilityOrder.dateOfService)}`} isOpen={isStatusBarVisible} changeStatusBarVisibility={() => changeStatusBarVisibility()} isInventoryStepAllowed={isInventoryStepAllowed}>
                <div className="content__header__actions">
                    <h3 className="type--med type--wgt--bold u-mar--top--tny"></h3>
                    <ReactTooltip positionStrategy="fixed" id="facilityPreviewTooltip" place="bottom" />
                    <a className="btn btn--base btn--light u-mar--right--tny" target='_blank' data-tooltip-content="Facility Preview" data-tooltip-id="facilityPreviewTooltip" onClick={() => goToFacilityPreview()}><i className="u-icon u-icon--sml u-icon--preview--dark"></i></a>
                    
                    <ReactTooltip positionStrategy="fixed" id="orderingTooltip" place="bottom" />
                    <a className="btn btn--base btn--light u-mar--right--tny" target='_blank' data-tooltip-content="Ordering Calendar" data-tooltip-id="orderingTooltip" onClick={() => goToFacilityCalendar()}><i className="u-icon u-icon--sml u-icon--schedules"></i></a>
                    
                    <ReactTooltip positionStrategy="fixed" id="reportTooltip" place="bottom" />
                    <a className="btn btn--base btn--light" target='_blank' data-tooltip-content="FO Report Download" data-tooltip-id="reportTooltip" onClick={() => downloadFacilityOrder()}><i className="u-icon u-icon--sml u-icon--download--brand"></i></a>
                </div>
            </FacilityOrderNewFlowStatusBar>

            <div className="u-flex--space-between">
                <div className="tabs__wrapper">
                    <div className="tabs tabs--fullwidth">
                        {tabButtons}
                    </div>
                </div>
                <div className="u-flex--default u-mar--left--auto">
                    {!isDisabled() && !(facilityOrderStatus && facilityOrderStatus.startedOn) && <BaasicButton className="btn btn--base btn--primary u-mar--right--sml" label="Start" disabled={disabledStatus || disabledSendOrder} onClick={() => setInsuranceStarted()} />}
                </div>
            </div>
            {
                isDisabled() &&
                <div className="u-mar--bottom--sml">
                    {
                        usIntakeStatus && facilityOrderStatus && facilityOrderStatus.startedOn ? 'US Intake has started working on this facility. No further adjustments can be made from the Insurance Review flow' :
                            usIntakeStatus && !facilityOrderStatus ? 'Insurance Review cannot be worked on because US Intake has already started working on this facility order.' :
                                'Insurance Review cannot be started because Initial Intake is not yet completed.'
                    }
                </div>
            }

            {
                (
                    (facilityOrderTemplateStores && facilityOrderTemplateStores.length > 0) ?
                        facilityOrderTemplateStores.map(store => {
                            return (
                                <div key={store.id}>
                                    <FacilityOrderTemplateNewFlowInsuranceEdit
                                        facilityOrderTemplateNewFlowInsuranceEditViewStore={store}
                                        disabled={disabled || disabledSendOrder}
                                        disabledSendOrder={disabledSendOrder}
                                    />
                                </div>
                            );
                        })
                        :
                        (facilityOrderTemplateStores && facilityOrderTemplateStores.length === 0 && facilityOrder && selectedStatusAbrv === 'in-progress' &&
                            (facilityOrderStatus && facilityOrderStatus.completedOn ?
                                <div>
                                    <div className="row row--form u-mar--top--sml">
                                        <div className="col form__group">
                                            Insurance Review has been completed on {moment(facilityOrderStatus.completedOn).format("MM/DD/YYYY, hh:mm A")}
                                        </div>
                                    </div>
                                    <div>
                                        {isInsuranceStatus && <div className="empty-state--facility-orders">
                                            <div className="empty-state--facility-orders--table"></div>
                                            <p className="empty-state--facility-orders--description">You have no orders in progress!</p>
                                            {!isDisabled() && facilityOrderStatus && facilityOrderStatus.startedOn && <BaasicButton className="btn btn--base btn--primary" label="Restart Insurance Review" disabled={disabledStatus || disabledSendOrder} onClick={() => restartInsuranceReview()} />}
                                        </div>}
                                    </div>
                                </div>
                                :
                                (!itemCategoryStore.value) ?
                                    (
                                        <div className="empty-state--facility-orders">
                                            <div className="empty-state--facility-orders--table"></div>
                                            <p className="empty-state--facility-orders--description">You have no orders in progress!</p>
                                            {!isDisabled() && facilityOrderStatus && facilityOrderStatus.startedOn && <BaasicButton className="btn btn--base btn--primary" label="Insurance is Complete" disabled={disabledStatus || disabledSendOrder} onClick={() => setInsuranceCompleted()} />}
                                        </div>
                                    )
                                    :
                                    null
                            )
                        )
                )
            }
            <ScrollToTopButton />
        </PreviewLayout>
    )
}

FacilityOrderNewFlowInsurancePreviewTemplate.propTypes = {
    facilityOrderNewFlowInsurancePreviewViewStore: PropTypes.object.isRequired
};

export default defaultTemplate(FacilityOrderNewFlowInsurancePreviewTemplate);